<template>
  <Select
    class="pets-list__select"
    :placeholder="placeholder"
    :value="selectedPetId"
    :options="formattedPets"
    :empty-text="emptyStateText"
    :is-disabled="isDisabled"
    :select-first-by-default="selectFirstPet"
    value-key="id"
    label-key="displayLabel"
    @beforeChange="onBeforeChange"
    @input="handlePetSelect"
  >
    <template #option="{ option }">
      <div v-if="option" class="pets-list-option">
        <p class="pets-list-option__info-text">
          <strong>Кличка:</strong> {{ option.pet_alias }}
        </p>
        <p class="pets-list-option__info-text">
          <strong>Тип:</strong> {{ option.pet_type_label }}
        </p>
        <p class="pets-list-option__info-text">
          <strong>Порода:</strong> {{ option.pet_breed }}
        </p>
        <p class="pets-list-option__info-text">
          <strong>Стать:</strong> {{ option.pet_sex_label }}
        </p>
        <p class="pets-list-option__info-text">
          <strong>Дата народження:</strong> {{ formatDate(option.pet_birth_date, 'DD-MM-YYYY') }}
        </p>
      </div>
    </template>
  </Select>
</template>

<script>
import { DateFormatter } from '@/shared/lib/calendar';
import { Select } from '@/shared/ui/form';

const { formatDate } = DateFormatter();

export default {
  model: {
    prop: 'pet',
    event: 'input'
  },
  props: {
    placeholder: {
      type: String,
      default: 'Оберіть тварину клієнта',
    },
    pet: {
      type: [String, Number, null],
      default: null,
    },
    pets: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    selectFirstPet: {
      type: Boolean,
      default: true,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      selectedPetId: null
    };
  },
  mounted() {
    this.initializeSelection();
  },
  components: { Select },
  computed: {
    formattedPets() {
      return this.pets?.map(pet => ({
        ...pet,
        displayLabel: pet?.displayLabel || this.buildDisplayLabel(pet),
      })) || [];
    },
  },
  methods: {
    formatDate,
    buildDisplayLabel(pet) {
      const parts = [];
      if (pet?.pet_alias) parts.push(pet.pet_alias);
      if (pet?.pet_type_label) parts.push(pet.pet_type_label);
      else if (pet?.pet_type) parts.push(this.getPetTypeLabel(pet.pet_type));
      if (pet?.pet_breed) parts.push(pet.pet_breed);
      return parts.join(' ');
    },
    getPetTypeLabel(typeId) {
      const labels = { 1: 'Кіт', 2: 'Собака' };
      return labels[typeId] || '';
    },
    initializeSelection() {
      if (this.pet != null) {
        const petById = this.formattedPets.find(p => p.id === this.pet);
        if (petById) {
          this.handlePetSelect(this.pet);
          return;
        }
      }

      if (this.pets?.length === 1 && this.selectFirstPet) {
        this.handlePetSelect(this.pets[0]?.id);
      }
    },
    handlePetSelect(selectedId) {
      const selectedPet = this.formattedPets.find(pet => pet.id === selectedId);
      this.selectedPetId = selectedPet ? selectedId : null;
      this.$emit('input', selectedPet || null);
      this.$emit('change', selectedPet || null);
    },
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
  watch: {
    pet: {
      handler(newPet) {
        if (newPet != null) {
          const petById = this.formattedPets.find(p => p.id === newPet);
          if (petById) {
            this.handlePetSelect(newPet);
            return;
          }
        } else {
          this.selectedPetId = null;
          this.$emit('input', null);
          this.$emit('change', null);
        }
      },
    },
    pets: {
      handler() {
        this.initializeSelection();
      },
    }
  },
};
</script>

<style lang="scss" scoped>
.pets-list__select {
  width: 100%;
}

.pets-list-option {
  &__info-text {
    margin: 0;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    strong {
      font-weight: 600;
    }
  }
}
</style>
